import React, { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const dot = useRef(null);
  const ring = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    setEnabled(true);
    let rx = 0, ry = 0, x = 0, y = 0;
    const move = (e) => {
      x = e.clientX; y = e.clientY;
      if (dot.current) { dot.current.style.left = `${x}px`; dot.current.style.top = `${y}px`; }
    };
    const raf = () => {
      rx += (x - rx) * 0.18; ry += (y - ry) * 0.18;
      if (ring.current) { ring.current.style.left = `${rx}px`; ring.current.style.top = `${ry}px`; }
      requestAnimationFrame(raf);
    };
    const over = (e) => {
      const t = e.target.closest("a,button,[data-cursor='link'],input,textarea,select");
      if (ring.current) ring.current.style.transform = `translate(-50%,-50%) scale(${t ? 1.6 : 1})`;
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    const id = requestAnimationFrame(raf);
    return () => { window.removeEventListener("mousemove", move); window.removeEventListener("mouseover", over); cancelAnimationFrame(id); };
  }, []);

  if (!enabled) return null;
  return (<>
    <div ref={dot} className="gold-cursor" />
    <div ref={ring} className="gold-cursor-ring" />
  </>);
}
